import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { ShopifyOrdersPage } from "@/components/shopify/shopify-orders-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/shopify-orders",
  loader: async () => {
    const res = await fetch("/api/shopify/orders?pageSize=50&sortBy=shopifyCreatedAt&sortDir=desc");
    if (!res.ok) return { orders: [], total: 0 };
    return res.json();
  },
  component: ShopifyOrdersPageGuard,
});

function ShopifyOrdersPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  // biome-ignore lint/suspicious/noExplicitAny: better-auth session type lacks role
  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <ShopifyOrdersPage />;
}
